'use client';

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  DialogCloseButton,
} from '@hc-frontend/core-ui';
import { useState } from 'react';

import { ConnectMeButton } from '../../atoms/connect-me-button';
import { Countdown } from '../../atoms/countdown/countdown';
import { TypConnectMeHolder } from '../../molecules/typ-connect-me-holder/typ-connect-me-holder';
import { useUccModalDataContext } from './modal-data-provider';
import { useModalCommonUtils } from './use-modal-common-utils';

export function UccModalContentSimplified() {
  const {
    phoneNumber,
    primaryCampaign,
    metricName,
    experience,
    sessionId,
    product,
    placement,
  } = useUccModalDataContext();

  const {
    isOpen,
    isInitCall,
    internalRef,
    closeId,
    connectMeButtonId,
    connectMeDestinationPhoneNumber,
    handleOnClickBackdrop,
    handleOnClickClose,
    handleOnCountdownClose,
    handleOnClickConnectMe,
  } = useModalCommonUtils();

  const [cardHeaderText, setCardHeaderText] = useState(
    'A licensed insurance agent just became available!',
  );

  return (
    <div className="hc-imposter-layout">
      <dialog
        aria-modal="true"
        ref={internalRef}
        onClick={handleOnClickBackdrop}
        className="max-w-[800px] rounded-md bg-gray-0 text-center text-text-950 shadow-lg backdrop:bg-[rgba(0,0,0,0.65)]"
      >
        <Card className="w-full">
          <CardHeader className="hc-icon-layout--right relative justify-center px-32-60 py-4-16">
            {cardHeaderText}
            <DialogCloseButton onClick={handleOnClickClose} />
          </CardHeader>
          <CardBody className="hc-stack-layout--large">
            {isInitCall ? (
              <TypConnectMeHolder
                metricName={metricName}
                experience={experience}
                phoneNumber={phoneNumber}
                destinationPhoneNumber={connectMeDestinationPhoneNumber}
                placement={placement}
                sessionId={sessionId}
                product={product}
                setCardHeaderText={setCardHeaderText}
                advertiser={primaryCampaign.advertiser}
              />
            ) : (
              <>
                <p
                  className="hc-typography--paragraph-md"
                  data-testid="initial-connect-me-message"
                >
                  To connect, click{' '}
                  <span className="font-bold underline">Connect Me</span> and
                  pick up the phone when it rings
                </p>
                <span className="hc-typography--title-case">
                  {isOpen ? (
                    <Countdown
                      initialSeconds={45}
                      onEnd={handleOnCountdownClose}
                    />
                  ) : null}
                </span>
                <h3 className="hc-typography--heading-three">seconds</h3>
                <p className="hc-typography--paragraph-md">
                  Your spot will go to another caller if you do not answer
                </p>
              </>
            )}

            {isInitCall ? (
              <Button
                id={closeId}
                variant="primary-card"
                type="button"
                className="w-full"
                onClick={handleOnClickClose}
              >
                <p className="mx-auto">Close</p>
              </Button>
            ) : (
              <ConnectMeButton
                className="w-full"
                id={connectMeButtonId}
                metricName={metricName}
                variant="primary-card"
                type="button"
                experience={experience}
                phoneNumber={phoneNumber}
                destinationPhoneNumber={connectMeDestinationPhoneNumber}
                callType={primaryCampaign.callType}
                placement={primaryCampaign.placement}
                sessionId={sessionId}
                product={product}
                isSendingDisplayMetric={false}
                onClick={handleOnClickConnectMe}
                advertiser={primaryCampaign.advertiser}
              >
                <p className="mx-auto">Connect Me</p>
              </ConnectMeButton>
            )}
          </CardBody>
        </Card>
      </dialog>
    </div>
  );
}
